<photo-provider>
  <photo-consumer
    v-for="(src, index) in imgList"
    :intro="getValue(src)"
    :key="index"
    :src="getValue(src)"
  >
    <div v-if="isLoading" @click.stop class="skeleton"></div>
    <img
      v-if="errorSrc"
      ref="image"
      @click.stop
      @load="onImageLoad"
      @error="onImageError"
      :src="errorSrc || getValue(src)"
      class="view-box"
      :class="className, { 'error-loaded': errorSrc }"
      :style="styleName"
    />
    <img
      v-else
      ref="image"
      @load="onImageLoad"
      @error="onImageError"
      :src="errorSrc || getValue(src)"
      class="view-box"
      :class="className, { 'error-loaded': errorSrc }"
      :style="styleName"
    />
    <div
      v-if="isDelete && !readonly && !isLoading"
      @click.stop
      class="c-image-is-delete"
    >
      <img
        @click="onDeleteImage(index)"
        :src="require('@/assets/icons/sidebars/delete.svg')"
        alt=""
      />
    </div>
    <div
      v-if="uploaded >= 1 && index === uploadedIndex && isFile(src)"
      @click.stop
      class="is-file-uploading"
    >
      <div class="upload-loader"></div>
    </div>
    <div v-if="file && isFile(src) && !isError" class="is-file-check">
      <i class="fa fa-file" aria-hidden="true"></i>
    </div>
    <div
      v-if="isError === src?.name"
      class="is-file-check"
      style="z-index: 3; color: var(--danger)"
    >
      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
    </div>
    <div
      v-show="isThumbnail && !readonly && !isLoading"
      @click.stop
      class="img-action"
    >
      <slot name="img-action" :row="src"></slot>
    </div>
    <div
      v-show="isThumbnail && thumbnail && thumbnail === src && !isLoading"
      @click.stop
      class="img-action-2"
    >
      <slot name="img-action" :row="src"></slot>
    </div>
  </photo-consumer>
</photo-provider>
